import { BlockchainStore } from 'types';
import { wallet } from './wallet';

export const blockchain: BlockchainStore = {
  wallet,
};
